<template>
  <div class="ca-pesquisa-bar rounded-xs gap-size-3 p-size-3">
    <SearchIconGrey class="ca-pesquisa-bar__icon" aria-hidden="true" />
    <input
      :value="modelValue"
      type="text"
      class="ca-pesquisa-bar__input caption-large"
      :aria-label="`Pesquisar`"
      @input="$emit('update:modelValue', $event.target.value)"
      @keydown.enter="$emit('submit')"
    />
    <button
      class="ca-pesquisa-bar__clear"
      aria-label="Limpar pesquisa"
      @click="$emit('clear')"
    >
      <CloseIcon class="ca-pesquisa-bar__close-icon" />
    </button>
  </div>
</template>

<script setup>
import SearchIconGrey from "@assets/search-icon-grey.svg";
import CloseIcon from "@assets/search-close.svg";

defineProps({
  modelValue: { type: String, default: "" },
});

defineEmits(["update:modelValue", "submit", "clear"]);
</script>

<style scoped lang="scss">
.ca-pesquisa-bar {
  display: flex;
  align-items: center;
  min-height: 48px;
  border: 1px solid var(--ca-color-text-light);
  background: var(--ca-color-text-inverted);
  transition: border-color 0.15s;

  &:focus-within {
    border-color: var(--ca-color-theme-primary);
  }

  &__icon {
    display: block;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
  }

  &__input {
    flex: 1;
    border: none;
    outline: none;
    color: var(--ca-color-text-body);
    background: transparent;
    min-width: 0;

    &::placeholder {
      color: var(--ca-color-text-body-variant);
    }
  }

  &__clear {
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    flex-shrink: 0;
    color: var(--ca-color-text-body-variant);

    &:hover {
      color: var(--ca-color-text-body);
    }

    &:focus-visible {
      outline: 1px solid var(--ca-color-feedback-info);
      outline-offset: 2px;
      border-radius: 10px;
    }
  }

  &__close-icon {
    display: block;
    width: 24px;
    height: 24px;

    :deep(path) {
      fill: currentColor;
    }
  }
}
</style>
